/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
import React from "react";

export default function Detailoem() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row pt-12 lg:pt-32">
      <div className="w-full flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 ">
        <h1 className="text-4xl lg:text-6xl text-theme-blue text-center font-bold leading-tight mb-5 lg:max-w-4xl mx-auto dark:text-white">
          OEM Solutions
        </h1>

        <p className="max-w-6xl mx-auto text-center font-light text-base lg:text-lg text-gray-400 leading-relaxed text-center ">
          Nube iO provides flexible OEM solutions like white labelling, custom
          hardware, and software development. We help businesses integrate
          advanced building automation technology, expanding their offerings
          with tailored, scalable solutions. Focusing on customisation,
          sustainability, and seamless IoT integration, our OEM services meet
          the unique.
        </p>
      </div>
    </section>
  );
}
